/*
 * Mlouye koleksiyon sayfası v1 (19.10.2026). Bağımlılık yok. Yalnız [data-mlc] bölümüne bağlanır.
 * 1) Görünüm 2/4 (750 px ve üstü). Tercih localStorage 'mlouye:collection-cols' (erişilemezse varsayılan).
 *    Görünüm değişince kart görsellerinin sizes değeri güncellenir (2 sütunda net görsel).
 * 2) Sort by: açılır liste (Esc ve dış tıklama kapatır). Linkler mevcut filtreleri korur.
 * 3) Filter: native <dialog> (odak içeride, Esc kapatır, odak açan düğmeye döner). Seçim değişince sonuçlar,
 *    sayılar ve "See results (N)" Section Rendering API ile yenilenir (250 ms). Adres replaceState ile güncellenir.
 * 4) Çip, "Clear all" ve sıralama linkleri sayfa yenilenmeden çalışır. Sayfalama linkleri normal geçiş (tema davranışı).
 * 5) Kart: lifestyle/2. görsel yalnız fare ya da klavye odağı gelince iner (olay yetkilendirmesi; yenilenen kartlarda da çalışır).
 * 6) v5.8 kart galerisi: oklar (masaüstü, link dışında, tıklama ürün sayfasına gitmez) ve yatay kaydırma (dokunmatik).
 *    Görseller 2..5 yalnız yaklaşınca iner (data-srcset). İlerleme çizgisi kaydırmayla güncellenir. Fare karttan çıkınca
 *    galeri ilk görsele döner (ızgara sakin kalsın). v5.9: dönüş her durumda (oka basılmış, kaydırma sürüyor olsa da).
 * 7) h (22.10.2026): kodsuz renk karesinin rengi ürünün kendi görselinden hesaplanır (hover/odakta).
 *    i (22.10.2026): kare hover'ında ad değişmez. Fareyle tıklanan kart linki odakta kalmaz (geri dönüşte kart açık kalmasın).
 * JS yoksa: form GET ile, linkler normal sayfa geçişiyle çalışır.
 * Ölçüm: Shopify.analytics.publish('mlouye_collection_filter' | 'mlouye_collection_sort' | 'mlouye_collection_view').
 */
(function () {
  if (window.__mlouyeCollectionV1) return;
  window.__mlouyeCollectionV1 = true;

  var KEY = 'mlouye:collection-cols';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function publish(name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail); } catch (e) {}
  }
  function readCols() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function writeCols(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function sizesFor(cols) { return cols === '4' ? '(min-width: 750px) 25vw, 50vw' : '50vw'; }

  function init(root) {
    if (root.dataset.mlcReady) return;
    root.dataset.mlcReady = '1';
    var sectionId = root.getAttribute('data-section-id');
    var drawer = root.querySelector('[data-mlc-drawer]');
    var form = root.querySelector('[data-mlc-form]');
    var openBtn = root.querySelector('[data-mlc-open-filters]');
    var controller = null;
    var timer = null;

    /* ---------- Görünüm 2/4 */
    var cols = readCols();
    if (cols !== '2' && cols !== '4') cols = root.getAttribute('data-default-cols') || '4';
    function applyCols(save) {
      var grid = root.querySelector('[data-mlc-grid]');
      if (grid) {
        grid.setAttribute('data-cols', cols);
        grid.querySelectorAll('.mlc-card__img').forEach(function (img) {
          if (img.hasAttribute('data-mlc-alt') || img.hasAttribute('data-mlc-lazy')) { img.dataset.sizes = sizesFor(cols); if (img.getAttribute('srcset')) img.setAttribute('sizes', sizesFor(cols)); }
          else if (img.getAttribute('srcset')) img.setAttribute('sizes', sizesFor(cols));
        });
      }
      root.querySelectorAll('[data-mlc-cols]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mlc-cols') === cols ? 'true' : 'false');
      });
      if (save) { writeCols(cols); publish('mlouye_collection_view', { columns: cols }); }
    }
    root.querySelectorAll('[data-mlc-cols]').forEach(function (b) {
      b.addEventListener('click', function () { cols = b.getAttribute('data-mlc-cols'); applyCols(true); });
    });
    applyCols(false);

    /* ---------- Model menüsü: oklar */
    var track = root.querySelector('[data-mlc-models-track]');
    if (track) {
      var prev = root.querySelector('[data-mlc-models-prev]');
      var next = root.querySelector('[data-mlc-models-next]');
      var rtl = getComputedStyle(track).direction === 'rtl';
      function updateArrows() {
        var max = track.scrollWidth - track.clientWidth;
        var pos = Math.abs(track.scrollLeft);
        if (prev) prev.hidden = max <= 2 || pos <= 2;
        if (next) next.hidden = max <= 2 || pos >= max - 2;
      }
      function step(dir) {
        var by = Math.max(track.clientWidth * 0.8, 200) * dir * (rtl ? -1 : 1);
        track.scrollBy({ left: by, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      var active = track.querySelector('[aria-current="page"]');
      if (active) {
        var li = active.parentElement;
        var target = li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2;
        if (target > 0) track.scrollLeft = rtl ? -target : target;
      }
      updateArrows();
    }

    /* ---------- Sort by */
    function bindSort() {
      var wrap = root.querySelector('[data-mlc-sort]');
      if (!wrap || wrap.dataset.mlcBound) return;
      wrap.dataset.mlcBound = '1';
      var toggle = wrap.querySelector('[data-mlc-sort-toggle]');
      function menu() { return wrap.querySelector('.mlc-sort__menu'); }
      function close(focus) {
        var m = menu(); if (!m || m.hidden) return;
        m.hidden = true; toggle.setAttribute('aria-expanded', 'false');
        if (focus) toggle.focus();
      }
      toggle.addEventListener('click', function () {
        var m = menu(); if (!m) return;
        var open = m.hidden;
        m.hidden = !open; toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var cur = m.querySelector('[aria-current="true"]') || m.querySelector('a'); if (cur) cur.focus(); }
      });
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });
      wrap.addEventListener('focusout', function (e) { if (e.relatedTarget && !wrap.contains(e.relatedTarget)) close(false); });
    }
    bindSort();

    /* ---------- Section Rendering */
    function sectionUrl(url) {
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }
    function cleanUrl(url) {
      var u = new URL(url, location.origin);
      u.searchParams.delete('section_id');
      u.searchParams.delete('page');
      return u.pathname + u.search;
    }
    function withCurrentFilters(href) {
      // Sıralama linki: mevcut adresteki filtreleri (fiyat dahil) korur, yalnız sort_by değişir.
      var target = new URL(href, location.origin);
      var cur = new URL(location.href);
      cur.searchParams.delete('page');
      cur.searchParams.set('sort_by', target.searchParams.get('sort_by') || '');
      return cur.pathname + cur.search;
    }

    function render(url, opts) {
      opts = opts || {};
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var grid = root.querySelector('[data-mlc-grid]');
      if (grid) grid.setAttribute('aria-busy', 'true');
      return fetch(sectionUrl(url), { signal: controller ? controller.signal : undefined, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-mlc]');
          if (!fresh) throw new Error('no section');
          ['grid', 'chips', 'pagination', 'count', 'count-sr', 'sort', 'filter-count', 'apply'].forEach(function (name) {
            var sel = '[data-mlc-region="' + name + '"]';
            var a = root.querySelector(sel), b = fresh.querySelector(sel);
            if (!a || !b) return;
            if (name === 'sort') { a.innerHTML = b.innerHTML; return; }
            if (name === 'filter-count') { a.textContent = b.textContent; a.hidden = b.hidden; return; }
            a.replaceWith(b);
          });
          // Panel: girdiler yerinde kalır (odak kaybolmaz), yalnız sayılar ve devre dışı durumu güncellenir.
          if (form) {
            var ff = fresh.querySelector('[data-mlc-form]');
            if (ff && opts.syncForm) {
              form.innerHTML = ff.innerHTML;
            } else if (ff) {
              form.querySelectorAll('[data-mlc-count-for]').forEach(function (c) {
                var twin = ff.querySelector('[data-mlc-count-for="' + CSS.escape(c.getAttribute('data-mlc-count-for')) + '"]');
                c.textContent = twin ? twin.textContent : '0';
              });
              var sortInput = form.querySelector('input[name="sort_by"]'), freshSort = ff.querySelector('input[name="sort_by"]');
              if (sortInput && freshSort) sortInput.value = freshSort.value;
            }
          }
          history.replaceState(null, '', cleanUrl(url));
          applyCols(false);
          bindLinks();
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; location.href = cleanUrl(url); })
        .finally(function () { var g = root.querySelector('[data-mlc-grid]'); if (g) g.removeAttribute('aria-busy'); });
    }

    function formUrl() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var q = params.toString();
      return form.getAttribute('action') + (q ? '?' + q : '');
    }

    if (form) {
      form.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var url = formUrl();
          render(url);
          publish('mlouye_collection_filter', { url: cleanUrl(url) });
        }, 250);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(timer);
        render(formUrl()).then(function () { closeDrawer(); });
      });
    }

    /* ---------- Panel (native dialog) */
    var lastOpener = null;
    function closeDrawer() {
      if (drawer && drawer.open) drawer.close();
    }
    if (drawer && openBtn) {
      if (typeof drawer.showModal !== 'function') {
        // Çok eski tarayıcı: panel yerine normal sayfa formu yok; filtre düğmesi gizlenir, sıralama ve linkler çalışır.
        openBtn.hidden = true;
      } else {
        openBtn.addEventListener('click', function () {
          lastOpener = openBtn;
          drawer.showModal();
          document.documentElement.style.overflow = 'hidden';
        });
        drawer.addEventListener('close', function () {
          document.documentElement.style.overflow = '';
          if (lastOpener) lastOpener.focus();
        });
        drawer.addEventListener('click', function (e) {
          if (e.target === drawer) closeDrawer(); // backdrop
          if (e.target.closest('[data-mlc-close]')) closeDrawer();
        });
      }
    }

    /* ---------- Linkler: çip, temizle, sıralama */
    function bindLinks() {
      root.querySelectorAll('[data-mlc-link]').forEach(function (a) {
        if (a.dataset.mlcBound) return;
        a.dataset.mlcBound = '1';
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          e.preventDefault();
          var isSort = a.classList.contains('mlc-sort__option');
          var href = isSort ? withCurrentFilters(a.href) : a.href;
          if (isSort) {
            var wrap = root.querySelector('[data-mlc-sort]');
            var m = wrap && wrap.querySelector('.mlc-sort__menu');
            var t = wrap && wrap.querySelector('[data-mlc-sort-toggle]');
            if (m) m.hidden = true;
            if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
            publish('mlouye_collection_sort', { url: href });
          }
          render(href, { syncForm: true }).then(function () { if (a.hasAttribute('data-mlc-clear')) closeDrawer(); });
        });
      });
    }
    bindLinks();

    /* ---------- Kart: hover görseli (yetkilendirme) */
    function loadAlt(card) {
      var alt = card.querySelector('[data-mlc-alt]');
      if (!alt || alt.dataset.mlcRequested) return;
      alt.dataset.mlcRequested = '1';
      alt.addEventListener('load', function () { alt.classList.add('is-loaded'); card.classList.add('is-alt-ready'); }, { once: true });
      alt.setAttribute('sizes', alt.dataset.sizes || sizesFor(cols));
      alt.setAttribute('srcset', alt.dataset.srcset);
    }
    root.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('[data-mlc-card]');
      if (card) { loadAlt(card); loadSwatches(card); }
    });
    root.addEventListener('focusin', function (e) {
      if (!fine.matches) return;
      var card = e.target.closest && e.target.closest('[data-mlc-card]');
      if (card) { loadAlt(card); loadSwatches(card); }
    });

    /* ---------- h (22.10.2026): kodsuz renk karesi + karede renk adı önizlemesi
       Kodsuz renk karesi (data-mlc-sw) yalnız hover/odakta ürünün 96 px'lik ilk görselini indirir (~2 KB) ve
       baskın rengi hesaplar: zemin (köşelerin ortalaması) ayıklanır, gölge (en koyu %20) ve parlama (en açık %10)
       atılır, kalan pikseller 8x8x8 kutuya bölünür, en kalabalık kutunun ortalaması kare rengi olur.
       Sonuç sekme boyunca sessionStorage'da tutulur (erişilemezse her seferinde hesaplanır). Görsel okunamazsa kare
       çerçeveli boş kalır. */
    var swCache = {};
    function swKey(u) { return (u || '').split('?')[0].split('/').pop() + '|' + (((u || '').match(/[?&]v=(\d+)/) || [])[1] || ''); }
    function swRead(k) { try { return sessionStorage.getItem('mlouye:sw:' + k); } catch (e) { return null; } }
    function swWrite(k, v) { try { sessionStorage.setItem('mlouye:sw:' + k, v); } catch (e) {} }
    function hex2(n) { n = Math.max(0, Math.min(255, Math.round(n))); return (n < 16 ? '0' : '') + n.toString(16); }
    function dominant(img) {
      var N = 48, c = document.createElement('canvas');
      c.width = N; c.height = N;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#f3f3f3'; x.fillRect(0, 0, N, N);
      x.drawImage(img, 0, 0, N, N);
      var d = x.getImageData(0, 0, N, N).data;
      var cs = [0, (N - 1) * 4, N * (N - 1) * 4, (N * N - 1) * 4];
      var bg = [0, 1, 2].map(function (k) { return cs.reduce(function (s, i) { return s + d[i + k]; }, 0) / 4; });
      var px = [];
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i], g = d[i + 1], b = d[i + 2];
        if (Math.abs(r - bg[0]) + Math.abs(g - bg[1]) + Math.abs(b - bg[2]) < 36) continue;
        px.push([r, g, b, 0.2126 * r + 0.7152 * g + 0.0722 * b]);
      }
      if (px.length < 40) return null;
      px.sort(function (a, b) { return a[3] - b[3]; });
      var box = {}, best = null;
      px.slice(Math.floor(px.length * 0.2), Math.ceil(px.length * 0.9)).forEach(function (p) {
        var k = (p[0] >> 5) + ',' + (p[1] >> 5) + ',' + (p[2] >> 5);
        var e = box[k] || (box[k] = [0, 0, 0, 0]);
        e[0]++; e[1] += p[0]; e[2] += p[1]; e[3] += p[2];
        if (!best || e[0] > best[0]) best = e;
      });
      return best ? '#' + hex2(best[1] / best[0]) + hex2(best[2] / best[0]) + hex2(best[3] / best[0]) : null;
    }
    function paintChip(chip, hex) {
      var r = parseInt(hex.substr(1, 2), 16), g = parseInt(hex.substr(3, 2), 16), b = parseInt(hex.substr(5, 2), 16);
      chip.style.setProperty('--mlc-chip', hex);
      if ((r * 299 + g * 587 + b * 114) / 1000 > 200) chip.classList.add('mlc-card__chip--light');
      chip.classList.add('is-sw-ready');
    }
    function loadSwatches(card) {
      card.querySelectorAll('[data-mlc-sw]').forEach(function (chip) {
        if (chip.dataset.mlcSwDone) return;
        chip.dataset.mlcSwDone = '1';
        var url = chip.getAttribute('data-mlc-sw');
        var k = swKey(url);
        var hex = swCache[k] || swRead(k);
        if (hex) { swCache[k] = hex; paintChip(chip, hex); return; }
        var abs;
        try { abs = new URL(url, location.href); } catch (e) { return; }
        var im = new Image();
        if (abs.origin !== location.origin) im.crossOrigin = 'anonymous';
        im.decoding = 'async';
        im.onload = function () {
          var h = null;
          try { h = dominant(im); } catch (e) { h = null; }
          if (!h) return;
          swCache[k] = h; swWrite(k, h);
          card.querySelectorAll('[data-mlc-sw="' + url.replace(/"/g, '\\"') + '"]').forEach(function (c) { paintChip(c, h); });
        };
        im.src = abs.href;
      });
    }
    /* i (22.10.2026, patron): karelerin üstünde gezerken kartın renk adı DEĞİŞMEZ; her zaman kartın kendi rengi.
       (h'deki ad önizlemesi kaldırıldı.) Kare tıklanınca o rengin ürününe gider. */

    /* ---------- Kart galerisi (v5.8) */
    function trackOf(card) { return card && card.querySelector('[data-mlc-track]'); }
    function slideW(t) { return t.clientWidth || 1; }
    function indexOf(t) { return Math.round(Math.abs(t.scrollLeft) / slideW(t)); }
    function loadSlide(t, i) {
      var s = t.children[i];
      var img = s && s.querySelector('[data-mlc-lazy]');
      if (!img || img.dataset.mlcRequested) return;
      img.dataset.mlcRequested = '1';
      img.setAttribute('sizes', img.dataset.sizes || sizesFor(cols));
      img.setAttribute('srcset', img.dataset.srcset);
    }
    function goTo(card, i, instant) {
      var t = trackOf(card);
      if (!t) return;
      var n = t.children.length;
      i = (i + n) % n;
      loadSlide(t, i);
      loadSlide(t, (i + 1) % n);
      var rtl = getComputedStyle(t).direction === 'rtl';
      t.scrollTo({ left: (rtl ? -1 : 1) * i * slideW(t), behavior: instant || reduce.matches ? 'auto' : 'smooth' });
    }
    function fileKey(v) { return (v || '').trim().split(/[\s,]/)[0].split('?')[0].split('/').pop(); }
    function altIndex(card, t) {
      var alt = card.querySelector('[data-mlc-alt]');
      if (!alt || !alt.classList.contains('is-loaded')) return -1;
      var key = fileKey(alt.dataset.srcset || alt.getAttribute('srcset'));
      for (var i = 0; i < t.children.length; i++) {
        var im = t.children[i].querySelector('img');
        if (im && fileKey(im.dataset.srcset || im.getAttribute('srcset') || im.src) === key) return i;
      }
      return -1;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mlc-prev], [data-mlc-next]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var card = b.closest('[data-mlc-card]');
      var t = trackOf(card);
      if (!t) return;
      // v5.9: ilk basışta ekranda hover görseli (lifestyle) varsa galeri onun sırasından devam eder;
      // yoksa ilk ok aynı lifestyle'ı ikinci kez gösteriyordu.
      var base = indexOf(t);
      if (!card.classList.contains('is-browsing')) { var ai = altIndex(card, t); if (ai >= 0) base = ai; }
      card.classList.add('is-browsing');
      goTo(card, base + (b.hasAttribute('data-mlc-next') ? 1 : -1));
    });
    root.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t.hasAttribute || !t.hasAttribute('data-mlc-track')) return;
      var pos = Math.abs(t.scrollLeft) / slideW(t);
      var fill = t.closest('[data-mlc-card]').querySelector('.mlc-card__bar-fill');
      if (fill) fill.style.setProperty('--mlc-i', pos.toFixed(3));
      var i = Math.round(pos);
      loadSlide(t, i);
      loadSlide(t, i + 1);
    }, { capture: true, passive: true });
    root.addEventListener('touchstart', function (e) {
      var t = e.target.closest && e.target.closest('[data-mlc-track]');
      if (t) loadSlide(t, 1);
    }, { passive: true });
    // v5.9: fare karttan çıkınca galeri her durumda ilk görsele döner. Oka fareyle basınca odak düğmeye geçmez
    // (geçerse :focus-within lifestyle'ı ve okları açık tutuyordu); klavye odağı aynen çalışır.
    root.addEventListener('mousedown', function (e) {
      if (e.target.closest && e.target.closest('[data-mlc-prev], [data-mlc-next]')) e.preventDefault();
      // i (22.10.2026): renk karesi ve +N fareyle tıklanınca odak almaz (tıklama ve geçiş aynen çalışır). Yoksa ürüne gidip
      // geri dönünce (bfcache) odak karede kalıyor, :focus-within kartı hover hâlinde tutuyordu (canlıda yeniden üretildi).
      if (e.button === 0 && e.target.closest && e.target.closest('.mlc-card__colors a')) e.preventDefault();
    });
    // i: kart linki (görsel/ad) fareyle tıklanıp geri dönülünce odak kartta kalabilir; sayfa önbellekten dönünce bırakılır.
    // Klavye odağı (:focus-visible) bırakılmaz.
    function releaseMouseFocus() {
      var ae = document.activeElement;
      if (!ae || !ae.closest || !root.contains(ae) || !ae.closest('[data-mlc-card]')) return;
      var kb = false;
      try { kb = ae.matches(':focus-visible'); } catch (err) { kb = false; }
      if (!kb) ae.blur();
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) releaseMouseFocus(); });
    function resetCard(card) {
      card.classList.remove('is-browsing');
      var t = trackOf(card);
      if (!t || t.scrollLeft === 0) return;
      // Süren yumuşak kaydırmayı ve snap'i kes, anında başa al.
      t.style.scrollSnapType = 'none';
      t.style.scrollBehavior = 'auto';
      t.scrollLeft = 0;
      var fill = card.querySelector('.mlc-card__bar-fill');
      if (fill) fill.style.setProperty('--mlc-i', '0');
      requestAnimationFrame(function () { t.scrollLeft = 0; t.style.scrollSnapType = ''; t.style.scrollBehavior = ''; });
    }
    function resetOnLeave(e) {
      var card = e.target.closest && e.target.closest('[data-mlc-card]');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      if (e.type === 'focusout' && card.matches(':hover')) return;
      if (e.type === 'mouseout' && card.contains(document.activeElement)) releaseMouseFocus();
      resetCard(card);
    }
    root.addEventListener('mouseout', function (e) { if (fine.matches) resetOnLeave(e); });
    root.addEventListener('focusout', function (e) { if (fine.matches) resetOnLeave(e); });
  }

  function boot() { document.querySelectorAll('[data-mlc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mlc]');
    if (el) init(el);
  });
})();
